module.exports = __webpack_public_path__ + "img/EsemeLogo.010bbde3.png";